import React, { useState } from 'react';
import { Box, Container, Typography, Button, Snackbar, Alert } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Download as DownloadIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { relatorioEstoqueService } from '../services/relatorioEstoque';

const RelatorioEstoque: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' as 'info' | 'error' });

  const downloadBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleGerarPorLinha = async () => {
    setLoading(true);
    setSnackbar({ open: true, message: 'Gerando relatório de estoque. Aguarde!', severity: 'info' });
    try {
      const blob = await relatorioEstoqueService.gerarRelatorioEstoquePorLinha();
      const dataRelatorio = new Date().toISOString();
      downloadBlob(blob, `Estoque_por_linha_${dataRelatorio}.xlsx`);
      setSnackbar({ open: true, message: 'Relatório gerado com sucesso.', severity: 'info' });
    } catch (error: any) {
      setSnackbar({ open: true, message: 'Erro ao gerar relatório: ' + (error.message || error), severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleGerarPorReferencia = async () => {
    setLoading(true);
    setSnackbar({ open: true, message: 'Gerando relatório de estoque. Aguarde!', severity: 'info' });
    try {
      const blob = await relatorioEstoqueService.gerarRelatorioEstoquePorReferencia();
      const dataRelatorio = new Date().toISOString();
      downloadBlob(blob, `Estoque_por_referencia_${dataRelatorio}.xlsx`);
      setSnackbar({ open: true, message: 'Relatório gerado com sucesso.', severity: 'info' });
    } catch (error: any) {
      setSnackbar({ open: true, message: 'Erro ao gerar relatório: ' + (error.message || error), severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleVoltar = () => {
    navigate('/Relatorios');
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Relatório de Estoque
        </Typography>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={handleVoltar}>
          Voltar
        </Button>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleGerarPorLinha}
          disabled={loading}
        >
          Gerar relatório por LINHA
        </Button>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleGerarPorReferencia}
          disabled={loading}
        >
          Gerar relatório por REFERÊNCIA
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default RelatorioEstoque;
